import loginEn from './pages/Login/en.json'
import disciplinesPageEn from './pages/VirtualRoomPage/ContentPage/DisciplinesPage/en.json'
import announcementsEn from './pages/Announcements/en.json'
import dropzoneAreaEn from './components/DropzoneArea/en.json'
import seeMoreComponentEn from './components/SeeMoreComponent/en.json'
import modalBodyComponentEn from './components/ModalBodyComponent/en.json'
import lessonsPageEn from './pages/VirtualRoomPage/ContentPage/LessonsPage/en.json'
import forumPageEn from './pages/VirtualRoomPage/ForumPage/en.json'
import forumClassesPageEn from './pages/VirtualRoomPage/ForumPage/ForumClassesPage/en.json'
import listForumPageEn from './pages/VirtualRoomPage/ForumPage/ListForumPage/en.json'
import boxComponentEn from './components/BoxComponent/en.json'
import newTopicPageEn from './pages/VirtualRoomPage/ForumPage/NewTopicPage/en.json'
import inputComponentEn from './components/InputComponent/en.json'
import uploadComponentEn from './components/UploadComponent/en.json'
import editTopicPageEn from './pages/VirtualRoomPage/ForumPage/EditTopicPage/en.json'
import imageEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Image/en.json'
import videoEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Video/en.json'
import audioEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Audio/en.json'
import attachmentEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Attachment/en.json'
import feedForumPageEn from './pages/VirtualRoomPage/ForumPage/FeedForumPage/en.json'
import datesEn from './pages/VirtualRoomPage/ForumPage/components/EditTopicForum/components/Dates/en.json'
import classesEn from './pages/VirtualRoomPage/ForumPage/components/EditTopicForum/components/Classes/en.json'
import indexEditTopicForumEn from './pages/VirtualRoomPage/ForumPage/components/EditTopicForum/components/index/en.json'
import helpPageEn from './pages/VirtualRoomPage/HelpPage/en.json'
import liveClassPageEn from './pages/VirtualRoomPage/LiveClassPage/en.json'
import contentEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/Content/en.json'
import conquestPageEn from './pages/VirtualRoomPage/ConquestPage/en.json'
import finalEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/Final/en.json'
import inputAttachEn from './pages/VirtualRoomPage/ForumPage/components/InputAttach/en.json'
import inputTextEn from './pages/VirtualRoomPage/ForumPage/components/InputText/en.json'
import pendencyWarningEn from './pages/VirtualRoomPage/ForumPage/components/PendencyWarning/en.json'
import postPublishEn from './pages/VirtualRoomPage/ForumPage/components/PostPublish/en.json'
import pendenciesEn from './pages/VirtualRoomPage/ForumPage/ListForumPage/components/Pendencies/en.json'
import classesPageEn from './pages/VirtualRoomPage/ContentPage/ClassesPage/en.json'
import activityEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/Activity/en.json'
import multipleChoiceEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/MultipleChoice/en.json'
import orderEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/Order/en.json'
import menuDropupEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/MenuDropup/en.json'
import clueEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/media/Clue/en.json'
import confirmationEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/Confirmation/en.json'
import lessonsEn from './pages/VirtualRoomPage/ForumPage/components/EditTopicForum/components/Lessons/en.json'
import forumFeedEn from './pages/VirtualRoomPage/ForumPage/components/ForumFeed/en.json'
import classesPageRankingEn from './pages/VirtualRoomPage/RankingPage/ClassesPage/en.json'
import rankingListPageEn from './pages/VirtualRoomPage/RankingPage/RankingListPage/en.json'
import disciplinesPageRankingEn from './pages/VirtualRoomPage/RankingPage/DisciplinesPage/en.json'
import attendanceReportEn from './pages/VirtualRoomPage/LiveClassPage/AttendanceReport/en.json'
import classRoomPageEn from './pages/VirtualRoomPage/LiveClassPage/ClassRoomPage/en.json'
import joinLiveClassEn from './pages/VirtualRoomPage/LiveClassPage/JoinLiveClass/en.json'
import liveClassModalsEn from './pages/VirtualRoomPage/LiveClassPage/Modals/en.json'
import pastClassesLiveEn from './pages/VirtualRoomPage/LiveClassPage/PastClasses/en.json'
import correctionModalEn from './pages/VirtualRoomPage/TaskDeliveryPage/modals/CorrectionModal/en.json'
import deleteTaskDeliveryModalEn from './pages/VirtualRoomPage/TaskDeliveryPage/modals/DeleteTaskDeliveryModal/en.json'
import allWorksEn from './pages/VirtualRoomPage/TaskDeliveryPage/tabs/all-works/en.json'
import correctionsEn from './pages/VirtualRoomPage/TaskDeliveryPage/tabs/corrections/en.json'
import newTaskEn from './pages/VirtualRoomPage/TaskDeliveryPage/tabs/new-task/en.json'
import studentWorksEn from './pages/VirtualRoomPage/TaskDeliveryPage/tabs/student-works/en.json'
import taskDeliveryPageEn from './pages/VirtualRoomPage/TaskDeliveryPage/en.json'
import profileAreaComponentEn from './components/ProfileAreaComponent/en.json'
import editProfilePageEn from './pages/EditProfilePage/en.json'
import roadBarStoreEn from './stores/RoadBarStore/en.json'
import forumStoreEn from './stores/ForumStore/en.json'
import courseStoreEn from './stores/CourseStore/en.json'
import reportsStoreEn from './stores/ReportsStore/en.json'
import trailStoreEn from './stores/TrailStore/en.json'
import virtualRoomStoreEn from './stores/VirtualRoomStore/en.json'
import disciplineStoreEn from './stores/DisciplineStore/en.json'
import IconBellComponentEn from './components/IconBellComponent/en.json'
import IconChatComponentEn from './components/IconChatComponent/en.json'
import NotificationAreaComponentEn from './components/NotificationAreaComponent/en.json'
import ChatEn from './components/Chat/en.json'
import UtilEn from './Util/en.json'
import editLiveClassEn from './components/IES2/EditLiveClass/en.json'
import liveClassCardEn from './components/IES2/LiveClassCard/en.json'
import ies2InputEn from './components/IES2/Input/en.json'
import forumModelEn from './models/ForumModel/en.json'
import jitsiEn from './components/IES2/JitsiIES2/en.json'
import tfActivityEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/TF/en.json'
import writtenEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/activities/Written/en.json'
import reportsClassesPageEn from './pages/VirtualRoomPage/ReportsPage/ClassesPage/en.json'
import reportsProgressEn from './pages/VirtualRoomPage/ReportsPage/Progress/en.json'
import reportsPerformanceEn from './pages/VirtualRoomPage/ReportsPage/Performance/en.json'
import reportsStudentPageEn from './pages/VirtualRoomPage/ReportsPage/StudentPage/en.json'
import reportsProgressPerformancePageEn from './pages/VirtualRoomPage/ReportsPage/ProgressPerformancePage/en.json'
import reportsModalMessageComponentEn from './pages/VirtualRoomPage/ReportsPage/ModalMessageComponent/en.json'
import vimeoEn from './components/IES2/Vimeo/en.json'
import lessonContentPageEn from './pages/VirtualRoomPage/ContentPage/LessonContentPage/en.json'
import formErrorsEn from './forms/errors/en.json'

const en = {
  ...loginEn,
  ...disciplinesPageEn,
  ...announcementsEn,
  ...dropzoneAreaEn,
  ...seeMoreComponentEn,
  ...modalBodyComponentEn,
  ...lessonsPageEn,
  ...forumPageEn,
  ...forumClassesPageEn,
  ...listForumPageEn,
  ...boxComponentEn,
  ...newTopicPageEn,
  ...inputComponentEn,
  ...uploadComponentEn,
  ...editTopicPageEn,
  ...imageEn,
  ...videoEn,
  ...audioEn,
  ...attachmentEn,
  ...feedForumPageEn,
  ...datesEn,
  ...classesEn,
  ...indexEditTopicForumEn,
  ...helpPageEn,
  ...liveClassPageEn,
  ...contentEn,
  ...conquestPageEn,
  ...finalEn,
  ...inputAttachEn,
  ...inputTextEn,
  ...pendencyWarningEn,
  ...postPublishEn,
  ...pendenciesEn,
  ...classesPageEn,
  ...activityEn,
  ...multipleChoiceEn,
  ...orderEn,
  ...menuDropupEn,
  ...clueEn,
  ...confirmationEn,
  ...lessonsEn,
  ...forumFeedEn,
  ...classesPageRankingEn,
  ...disciplinesPageRankingEn,
  ...rankingListPageEn,
  ...classRoomPageEn,
  ...liveClassModalsEn,
  ...pastClassesLiveEn,
  ...attendanceReportEn,
  ...joinLiveClassEn,
  ...correctionModalEn,
  ...deleteTaskDeliveryModalEn,
  ...allWorksEn,
  ...correctionsEn,
  ...newTaskEn,
  ...studentWorksEn,
  ...taskDeliveryPageEn,
  ...profileAreaComponentEn,
  ...editProfilePageEn,
  ...roadBarStoreEn,
  ...forumStoreEn,
  ...courseStoreEn,
  ...reportsStoreEn,
  ...trailStoreEn,
  ...virtualRoomStoreEn,
  ...disciplineStoreEn,
  ...IconBellComponentEn,
  ...IconChatComponentEn,
  ...NotificationAreaComponentEn,
  ...ChatEn,
  ...UtilEn,
  ...editLiveClassEn,
  ...liveClassCardEn,
  ...ies2InputEn,
  ...forumModelEn,
  ...jitsiEn,
  ...tfActivityEn,
  ...writtenEn,
  ...reportsClassesPageEn,
  ...reportsProgressEn,
  ...reportsPerformanceEn,
  ...reportsStudentPageEn,
  ...reportsProgressPerformancePageEn,
  ...reportsModalMessageComponentEn,
  ...vimeoEn,
  ...lessonContentPageEn,
  ...formErrorsEn
}

export default en
